//#region imports
import { Component, OnInit, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { SignatureService } from 'src/app/services/signature.service';
import { SignatureComponentModel, SaveAddressModel } from 'src/app/module/signature/model/signature.model';
import { ActivatedRoute } from '@angular/router';
import { RecapitulatoryComponentModel, SimulationReservationReason } from '../../model/recapitulatory.model';
import { SummaryService } from 'src/app/services/summary.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { SendDialogComponent } from './../../../../shared/components/dialogs/send-dialog/send-dialog.component';
import { RecallDialogComponent } from 'src/app/shared/components/dialogs/recall-dialog/recall-dialog.component';
import { P5xService } from 'src/app/services/p5x.service';
import { SaveService } from 'src/app/services/save.service';
import { SectionService } from 'src/app/services/section.service';
import { Globals } from 'src/app/services/globals';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
//#endregion

@Component({
  selector: 'app-recapitulatory',
  templateUrl: './recapitulatory.component.html',
  styleUrls: ['./recapitulatory.component.css']
})
export class RecapitulatoryComponent implements OnInit, AfterContentChecked {
  //#region variables
  disableP5XPrevious: boolean = false;
  premiumTotalAmtStr: string;
  clientId: string;
  language: string;
  simulationTokenValue: string;
  recapitulatoryComponent: RecapitulatoryComponentModel;
  signatureComponent: SignatureComponentModel;
  abexValue: string;
  showPremiumtag: boolean = false;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private signatureService: SignatureService,
    private summaryService: SummaryService, private activatedRoute: ActivatedRoute, private matDialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef, private sectionService: SectionService, 
    private p5xService: P5xService, private saveService: SaveService, private global: Globals) {
      this.language = this.guaranteeService.getLanguage();
     }

  ngOnInit() {
    const isRetrieveSimulation = this.sectionService.getIsRetrieveSimulation();
    if (isRetrieveSimulation) {
      if (this.p5xService.getIsP5XPage())
      {
        this.p5xService.setP5XProgressBarDetails();
        if(this.global.isMobile)
        {this.p5xService.setmobileP5XProgressBarDetails();}
      }
      else {
        this.summaryService.setSummaryProgressBarDetails();
        if(this.global.isMobile)
        {this.summaryService.setmobileSummaryProgressBarDetails();}
      }
      this.sectionService.setIsRetrieveSimulation(false);
    }
    
    this.activatedRoute.queryParams.subscribe((params) => {
      this.simulationTokenValue = params.simulationToken ? params.simulationToken : null;
    });
    this.summaryService.getRecapitulatoryComponent().subscribe((value) => {
      this.recapitulatoryComponent = value;
    });
    this.guaranteeService.getPremiumTotalAmount().subscribe((value) => {
      this.premiumTotalAmtStr = value;
    });
    this.guaranteeService.getPremiumTotalShow().subscribe((value) => {
      this.showPremiumtag = value;
    });
    this.abexValue = this.global.abexValueGlobal;
    // this.p5xService.disableP5XPrevious.subscribe((data: boolean) => {
    //   this.disableP5XPrevious = data;
    // });
    this.p5xService.getDisableP5XPrevious().subscribe((data) => {
      this.disableP5XPrevious = data;
      //console.log('p5xdisableprv:' + data);
    });
    // this.disableP5XPrevious = this.p5xService.getDisableP5XPrevious();
    if (this.global.p5xPrvDisable)
    {
      this.disableP5XPrevious = this.global.p5xPrvDisable;
    }
    this.global.charpage1=this.global.charpage2=this.global.charpage3=this.global.charpage4 =this.global.charpage5 = false;
  }

  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  btnFinalizeSimulation() {
    const isOwner = this.p5xService.getIsOwner();
    const isSecondaryResidence = this.p5xService.getSecondaryResidence();
    const isP41TheftChecked = this.p5xService.getP41TheftChecked();
    const minPrem = this.guaranteeService.getMinimumPremium();
    const totprem = this.global.totalPremium.replace(',', '.');
    
    if (this.global.isTheftZero) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
        Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    }else if (isOwner && isSecondaryResidence && isP41TheftChecked) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
        Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    } else if (Number(totprem) < Number(minPrem)) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.MinimumPremium.ID,
        Text: AppConstants.SimulationReservationReason.MinimumPremium.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    } else {
      this.sectionService.setCurrentPage('P5-1');
      // this.global.trackPageActivity += ';' + 'P5-1';
      const contactDetails = this.saveService.getContactDetails();
      const saveRequest = {
        firstName: contactDetails.FirstName,
        lastName: contactDetails.LastName,
        email: contactDetails.EmailAddress,
        phone: contactDetails.Telephone,
        code: contactDetails.PostalCode
      };
      this.global.sendSimulationMail = false;
      this.global.generateSimulation = true;
      this.global.SimulationDocumentum = true;
      this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
        this.saveService.setSimulationToken(data.Tocken);
        this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
        this.signatureService.setShowSignaturePrevious(false);
        this.signatureService.setShowSignatureNext(true);
        this.global.SimulationDocumentum = false;
        this.signatureService.setSignatureProgressBarDetails();
        if(this.global.isMobile)
        {this.signatureService.setmobileSignatureProgressBarDetails();}
        this.signatureService.setSignatureCurrentPage(true, false, false, false, false, false, false, false);
        const saveAddress: SaveAddressModel = {
          Taker_Civility: null,
          Taker_Name: null,
          Taker_Last_Name: null,
          Taker_BirthDate: null,
          Taker_Address_Post_Code: null,
          Taker_Address_Country: null,
          Taker_Address_Place: null,
          Taker_Address_Street: null,
          Taker_Address_Street_Number: null,
          Taker_Address_Box: null,
          Simulation_mail_Contact: null,
          Simulation_Phone_Contact: null,
          Property_Address_Street: null,
          Property_Address_Street_Number: null,
          Property_Address_Box: null,
          Premium_Frequency_paiement: null,
          Contract_other_company: false,
          Contract_start_date: null,
          Taker_Bank_Account_Number: null,
          Copy_Address: false
        };
        this.signatureService.setSaveAddress1(saveAddress);
        this.sectionService.navigate('signature', this.clientId, this.simulationTokenValue, this.language);
      });
    }
  }

  sendDialog() {
    const isOwner = this.p5xService.getIsOwner();
    const isSecondaryResidence = this.p5xService.getSecondaryResidence();
    const isP41TheftChecked = this.p5xService.getP41TheftChecked();
    const minPrem = this.guaranteeService.getMinimumPremium();
    const totprem = this.global.totalPremium.replace(',', '.');
    if (this.global.isTheftZero) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
        Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    } else if (isOwner && isSecondaryResidence && isP41TheftChecked) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.SecondHomeContent.ID,
        Text: AppConstants.SimulationReservationReason.SecondHomeContent.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    }else if (Number(totprem) < Number(minPrem)) {
      this.sectionService.setCurrentPage('P4-1');
      this.global.trackPageActivity += ';' + 'P4-1';
      this.saveService.setSimulationStatus('Simulation Reserved');
      this.summaryService.setRecapitulatoryCurrentPage(false, true);
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.MinimumPremium.ID,
        Text: AppConstants.SimulationReservationReason.MinimumPremium.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.p5xService.setP5XProgressBarDetails();
      if(this.global.isMobile)
      {this.p5xService.setmobileP5XProgressBarDetails();}
    }else{
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    this.matDialog.open(SendDialogComponent, dialogConfig);
    }
  }

  recallDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    this.matDialog.open(RecallDialogComponent, dialogConfig);
  }
  //#endregion
}
